import axios from 'axios'
import apiUrl from '../_const'

export default {
  getBillingList () {
    return axios.get(apiUrl.BILLING_URL + '/list', {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).then((response) => {
      return response.data
    }).catch((error) => {
      return new Error(error)
    })
  },
  getInterimBilling () {
    return axios.get(apiUrl.BILLING_URL + '/interim', {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).then((response) => {
      return response.data
    }).catch((error) => {
      return new Error(error)
    })
  },
  getPdfBilling ({commit}, data) {
    return axios({
      url: apiUrl.BILLING_URL + '/' + data.number,
      method: 'GET',
      responseType: 'blob',
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).then((response) => {
      return response.data
    }).catch((error) => {
      return new Error(error)
    })
  },
  getPrices () {
    return axios.get(apiUrl.BILLING_URL + '/prices', {
      headers: {'X-Auth-Jwt': window.sessionStorage.jwt}
    }).then((response) => {
      return response.data
    }).catch((error) => {
      return new Error(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/openstack/modules/billing.js